import { DtoBase, SharedModels } from '@project44-models/iam-gateway';

import { UnifiedRoleNotFoundException } from '../errors/UnifiedRoleNotFound.exception';

export class UnifiedRolesMapper {
  public static readonly TENANT_ADMIN_ROLE_ID: string = String('7');

  public static readonly NMC_LEGACY_TENANT_ADMIN_ROLE_NAME: string =
    String('Administrator').toLowerCase();

  public static readonly NMC_LEGACY_READ_ONLY_ROLE_NAME: string =
    String('Read-Only').toLowerCase();

  public static assertNMCLegacyTenantAdminRole(
    unifiedRole?: SharedModels.UnifiedRoleViewModel,
  ): SharedModels.UnifiedRoleViewModel {
    return this.handleMaybeNotAllowedUnifiedRole(
      unifiedRole?.name.toLowerCase() ===
        UnifiedRolesMapper.NMC_LEGACY_TENANT_ADMIN_ROLE_NAME
        ? unifiedRole
        : undefined,
    );
  }

  public static assertTenantAdminRole(
    unifiedRole?: SharedModels.UnifiedRoleViewModel,
  ): SharedModels.UnifiedRoleViewModel {
    return this.handleMaybeNotAllowedUnifiedRole(
      unifiedRole?.id === UnifiedRolesMapper.TENANT_ADMIN_ROLE_ID
        ? unifiedRole
        : undefined,
    );
  }

  public static assertNMCLegacyReadOnlyRole(
    unifiedRole?: SharedModels.UnifiedRoleViewModel,
  ): SharedModels.UnifiedRoleViewModel {
    return this.handleMaybeNotAllowedUnifiedRole(
      unifiedRole?.name.toLowerCase() ===
        UnifiedRolesMapper.NMC_LEGACY_READ_ONLY_ROLE_NAME
        ? unifiedRole
        : undefined,
    );
  }

  private static handleMaybeNotAllowedUnifiedRole = (
    maybeUnifiedRole?: SharedModels.UnifiedRoleViewModel | undefined,
  ): SharedModels.UnifiedRoleViewModel => {
    if (maybeUnifiedRole !== undefined) {
      return new DtoBase<SharedModels.UnifiedRoleViewModel>({
        model: maybeUnifiedRole,
      }).toSerializedModel();
    }

    throw UnifiedRoleNotFoundException.throw(maybeUnifiedRole);
  };
}
